/*
 * @Author: your name
 * @Date: 2021-06-24 19:00:49
 * @LastEditTime: 2023-10-19 09:29:10
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\login\index.js
 */
import request from '../request';
import { pwdEncryptUrl } from '../config';

const qs = require('qs');

const server = {
  getAuthTree() {
    return request.post('/ubm/ubmAuthority/backMenuTree');
  },
  // 获取用户信息
  getLoginInfo(params) {
    return request.fetch('/user-center/user/getLoginInfo', params);
  },
  // 退出登录
  mallLoginOut(params) {
    return request.fetch(
      `/user-center/user/mallLoginOut?${qs.stringify(params)}`
    );
  },
  // 获取公司列表
  getCompanyList(params) {
    return request.fetch(
      `/user-center/user/queryMemberCompany?${qs.stringify(params)}`
    );
  },

  // 切换公司
  switchCompany(params) {
    return request.fetch(
      `/user-center//user/switchCompany?${qs.stringify(params)}`
    );
  },
  // 获取用户菜单集合
  getAllMeunList(params) {
    return request.post(`/ubm/member/queryBackMenuList`, params);
  },
  // 密码加密
  getPublicKey(params) {
    return request.post(`${pwdEncryptUrl}/sam/auth/publicKey.do`, params);
  },
};

export default server;
